var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.navigationItems
    ? _c(
        "div",
        { staticClass: "container", attrs: { id: "settings-container" } },
        [
          _vm.mobileBigAndBelow
            ? _c(
                "div",
                { staticClass: "account-heading" },
                [
                  _c("icon", { attrs: { name: "icon-acc-settings" } }),
                  _vm._v(_vm._s(_vm.$t("Account.Settings")))
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "expansion-container" },
            _vm._l(_vm.navigationItems[0].fwnavigationitems, function(
              component,
              index
            ) {
              return _c(
                "v-expansion-panel",
                {
                  key: index,
                  attrs: {
                    expand: "",
                    value: _vm.expandedPanel.includes(component.cssclass)
                      ? 0
                      : 1,
                    id: [component.cssclass + "-panel"]
                  }
                },
                [
                  _c(
                    "v-expansion-panel-content",
                    {
                      attrs: {
                        "data-id": component.action,
                        id: component.cssclass,
                        lazy: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title-wrap",
                                    attrs: {
                                      "data-header": [component.cssclass],
                                      "data-component": [component.action]
                                    }
                                  },
                                  [
                                    _c("h1", [
                                      _vm._v(_vm._s(_vm.$t(component.area)))
                                    ])
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(component.action, {
                        key: _vm.componentKeys[component.action],
                        tag: "component"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "panel-bottom-border" })
                ],
                1
              )
            }),
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ee48e82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee48e82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/AccountSettings.vue
// module id = null
// module chunks = 